import { Component } from '@angular/core';
import { NavController,AlertController,NavParams,ModalController,LoadingController } from 'ionic-angular';
import * as firebase from 'firebase/app';
import * as moment from 'moment';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { Params } from '../../params';

@Component({
  templateUrl: 'selectcustomers.html' })
export class ManualTagsPage {
  customers : any;
  items = [];
  counter: number = 0;
  dia;
  foods;
  _foods;
  _menu;
  all : boolean = false;
  constructor(
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public navParams: NavParams,
    private nav: NavController
  ){
    this.dia = this.navParams.get('dia');
    this.foods = this.navParams.get('foods');
    this._foods = this.navParams.get('_foods');
    this._menu = this.navParams.get('_menu');

    /* this.customersRef = af.list('/customers');
    this.customersRef.subscribe(x => {
      x.selected = false;
      let cu = [];
      x.map((c)=>{
        if(c.active) cu.push(c);
      })
      this.items = cu;
      this.customers = cu;
    }); */

  }

  initializeItems(){
    this.items = this.customers;
  }

  selectAll(){
    this.customers.map((c)=>{
      c.selected = this.all;
    })
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (
          (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      })
    }
  }

  update(user,option){
    if(option){ this.counter++; }else{ this.counter--;}
    this.customers.filter((c) => {
        if(c.$key==user) c.selected = option;
    })
  }

  generateTags(){
    let cust = this.customers.filter((c) => {
      return c.selected
    })
    let loading = this.loadingCtrl.create({
      content: 'Generando etiquetas...'
    });
    loading.present();
    let charges = {};

    firebase.database().ref('/plans').orderByChild("active").equalTo(true).once('value')
      .then((snap2)=>{
        let plans = snap2.val();
        if(Object.keys(plans).length){
          let today = moment(this.dia).format("DD-MM-YYYY");
          let dd = {
            content: [],
            pageSize: 'FITFOOD',
            pageMargins : [ 20, 10, 10, 10 ],
            styles: {
              table: {
                "fontSize": 11,
                "margin": [0, 0, 0, 0],
              }
            }
          };
          let de = {
            content: [],
            pageSize: 'FITFOODSMALL',
            pageMargins : [ 50, 10, 10, 10 ],
            styles: {
              table: {
                "fontSize": 8,
                "margin": [0, 0, 0, 0],
              }
            }
          };
          let lt = [];
          let count = 0;
          let activos = 0;
          console.log("total clientes",cust.length);
          for(let i=0;i<cust.length;i++){
            let c = cust[i];
            let charge = {
              plan_name : c.plan,
              gender : c.sexo,
              foods : [],
              // day_value : Params.dayPrize(c,this._foods,false),
              shipping : false,
              noshipping_reason : "",
              noshipping_aditional_info : "",
              restrictions : "",
              discount: c.discount ? c.discount : 0,
              delivery: c.delivery ? c.delivery : 0,
              aditional_cost: c.aditional_cost ? c.aditional_cost : 0,
              aditional_cost_obs: c.aditional_cost_obs ? c.aditional_cost_obs : "",
            }

            charge.shipping = true;

              let restriction = "";
              if (typeof c.restrictions != "undefined"){
                Object.keys(c.restrictions).map(function(key) {
                  restriction+= c.restrictions[key].value_name + ", ";
                });
              }
              charge.restrictions = restriction;
              for (let j = 0; j < c.foods.length; j++) {
                let condition = "";
                if (typeof c.conditions != "undefined"){
                  condition = c.conditions[c.foods[j]] ? c.conditions[c.foods[j]] : '';
                }
                let route = ""; if (typeof c.route != "undefined") route = c.route;
                let venc_days = 4;

                if(this._menu[c.foods[j]]) { // se condiciona porque puede haber comidas nuevas sin estar asignadas
                  charge.foods.push({
                    "food_key" : c.foods[j],
                    "food_name" : this._foods[c.foods[j]].name,
                    "food_menu" : this._menu[c.foods[j]].name,
                    "condition" : condition
                  });


                  if (typeof this._menu[c.foods[j]].duration != "undefined") {
                    if (this._menu[c.foods[j]].duration > 0) venc_days = this._menu[c.foods[j]].duration;
                  }
                  let venc = moment(this.dia).add(venc_days, 'days').format("DD-MM-YYYY");
                  if (!this._foods[c.foods[j]].tag) {
                    //Etiqueta grande
                    dd.content.push({text: c.name + " " + c.lastname, bold: true, fontSize: 11});
                    dd.content.push({
                      style: 'table',
                      table: {
                        headerRows: 0,
                        widths: [110, 2, '*', 75],
                        body: [
                          [this._foods[c.foods[j]].name, ':', this._menu[c.foods[j]].name.substr(0, 40), {
                            text: plans[c.plan].name,
                            alignment: 'right'
                          }],
                          ['Condición', ':', " " + condition, {text: c.foods[j], alignment: 'right'}],
                          ['Restricción', ':', {text: restriction, color: "red"}, {
                            text: "Ruta:" + route,
                            alignment: 'right'
                          }]
                        ]
                      },
                      layout: 'lightHorizontalLines'
                    })
                    dd.content.push({
                      text: "Fecha elaboración: " + today + " / Consumir antes de: " + venc,
                      fontSize: 11
                    });
                    dd.content.push({text: '', margin: [0, 22, 0, 8]});
                  } else {
                    //Etiqueta chica
                    lt.push({
                      name: c.name + " " + c.lastname,
                      food: this._foods[c.foods[j]].name,
                      plate: this._menu[c.foods[j]].name,
                      restriction: restriction,
                      route: route,
                      condition: condition,
                      date: today
                    })
                  }
                }


              }
              charges[Params.md5(c.email)] = charge;
              // Finaliza de recorrer clientes y genera etiquetas
              if(cust.length==(i+1)){
                if(lt.length){
                  for(let w=0;w<lt.length;w++){
                    de.content.push({
                      style: 'table',
                      table: {
                        headerRows: 0,
                        widths: ['200', '200'],
                        body: [
                          [{
                            border: [false, false, false, false],
                            text: lt[w].food, bold: true, fontSize: 9
                          }],
                          [{
                            border: [false, false, false, false],
                            text: lt[w].name
                          }],
                          [{
                            border: [false, false, false, false],
                            text: 'Condición :'+ lt[w].condition
                          }],
                          [{
                            border: [false, false, false, false],
                            text: 'Restricción :'+ lt[w].restriction
                          }],
                          [{
                            border: [false, false, false, false],
                            text: "Fecha: "+lt[w].date+". Ruta: "+lt[w].route
                          }],
                        ]
                      }
                    })
                    de.content.push({text: '', margin: [0, 32, 0, 8]});

                  }
                }
                loading.dismiss();
                pdfMake.createPdf(dd).open();
                if(lt.length) pdfMake.createPdf(de).open();
                let send = {
                  data : charges,
                  date_client : moment().toISOString(),
                  date_server : firebase.database.ServerValue.TIMESTAMP,
                  owner : Params.md5(Params.USER_DATA.email),
                  tag_type : 'manual'
                }
               /*  this.charge = this.db.object('charges/'+moment(this.dia).format("YYYYMMDD"));
                this.charge.set(send); */
                this.nav.pop();
              }

            }
        }else{
          let alert = this.alertCtrl.create({
            title: 'No hay planes',
            subTitle: 'Debe crear planes o activar al menos uno',
            buttons: ['Aceptar']
          });
          alert.present();
        }
      });

    console.log(cust);
  }
}



// WEBPACK FOOTER //
// ./src/pages/menus/manualtag/manualtag.ts